(() => {
	const productTabsSections = document.querySelectorAll('.section.product-tabs');
	const animationTime = 151;

	const openProductTab = (tabContent, tabHeader) => {
		tabContent.classList.add('active');
        const tabIndex = tabHeader.getAttribute('data-js-product-tab-title');
        const selectedHeaders = document.querySelectorAll(`[data-js-product-tab-title="${tabIndex}"]`);

        selectedHeaders.forEach((header) => {
            header.classList.add('active');
        });
        
		window.requestAnimationFrame(() => {
			tabContent.classList.add('show');
		});
	};

	const closeProductTab = (tabContent, tabHeader) => {
		tabContent.classList.remove('show');
		tabHeader.classList.remove('active');
		setTimeout(() => {
			tabContent.classList.remove('active');
		}, animationTime);
	};

	productTabsSections.forEach((section) => {
		const isInitialized = section.getAttribute('init');
		if (isInitialized) return;

		document.addEventListener('DOMContentLoaded', () => {
			const swiperElement = section.querySelector('[data-js-product-tab-swiper]');

			const headerSwiper = new Swiper(swiperElement, {
				spaceBetween: 8,
				slidesPerView: 2.7,
				watchOverflow: true,
				breakpoints: {
					768: {
						slidesPerView: 16.3,
					},
				},
				on: {
					click(headerSwiper) {
						headerSwiper.slideTo(headerSwiper.clickedIndex);
					},
				},
			});

			const recipes = section.querySelector('[data-js-product-recipes-swiper]');

			if (recipes) {
				const recipeSwiper = new Swiper(recipes, {
					spaceBetween: 8,
					slidesPerView: 2.3,
					watchOverflow: true,
					breakpoints: {
						768: {
							spaceBetween: 16,
							slidesPerView: 5.3,
						},
					},
				});
			}
		});

		const tabHeaders = section.querySelectorAll('[data-js-product-tab-title]');
		const tabContents = section.querySelectorAll('[data-js-product-tab]');

		tabHeaders.forEach((header) => {
			header.addEventListener('click', () => {
				const headerIndex = header.getAttribute('data-js-product-tab-title');
				tabContents.forEach((content) => {
					const contentIndex = content.getAttribute('data-js-product-tab');

					if (headerIndex == contentIndex) {
						setTimeout(() => {
							openProductTab(content, header);
						}, animationTime);
					} else
						tabHeaders.forEach((header) => {
							const headerIndex = header.getAttribute('data-js-product-tab-title');

							if (contentIndex == headerIndex) {
								closeProductTab(content, header);
							}
						});
				});
			});
		});

		section.setAttribute('init', 'true');
	});
})();
